import React from 'react';
import { Box, Typography, Container, Grid, Link, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#1e293b',
  color: 'white',
  padding: '4rem 0 2rem 0',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: 'linear-gradient(90deg, #3b82f6, #06b6d4, #8b5cf6)'
  }
}));

const FooterContent = styled(Container)(({ theme }) => ({

}));

const FooterTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 700,
  marginBottom: '1.5rem',
  color: 'white'
}));

const FooterText = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#94a3b8',
  lineHeight: 1.7,
  marginBottom: '0.75rem'
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: '#94a3b8',
  textDecoration: 'none',
  transition: 'color 0.3s ease',
  '&:hover': {
    color: '#3b82f6'
  }
}));

const SocialContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '1rem',
  marginTop: '1rem'
}));

const SocialIcon = styled(IconButton)(({ theme }) => ({
  backgroundColor: 'rgba(59, 130, 246, 0.1)',
  color: '#3b82f6',
  width: '48px',
  height: '48px',
  '&:hover': {
    backgroundColor: '#3b82f6',
    color: 'white',
    transform: 'translateY(-2px)'
  },
  transition: 'all 0.3s ease'
}));

const Copyright = styled(Box)(({ theme }) => ({
  borderTop: '1px solid #374151',
  paddingTop: '2rem',
  marginTop: '3rem',
  textAlign: 'center'
}));

const BusinessDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#94a3b8',
  lineHeight: 1.7,
  marginBottom: '2rem'
}));

const Footer = ({ contact }) => {
  const {
    phone = '(555) 123-4567',
    email = 'contact@yourbusiness.com',
    address = '123 Business Street, City, State 12345'
  } = contact || {};

  return (
    <FooterContainer>
      <FooterContent maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <FooterTitle variant="h6">
              Your Business Name
            </FooterTitle>
            <BusinessDescription variant="body2">
              We provide exceptional services and products tailored to your needs. Our commitment to excellence drives everything we do.
            </BusinessDescription>
            <SocialContainer>
              <SocialIcon>
                <FacebookIcon />
              </SocialIcon>
              <SocialIcon>
                <TwitterIcon />
              </SocialIcon>
              <SocialIcon>
                <LinkedInIcon />
              </SocialIcon>
              <SocialIcon>
                <InstagramIcon />
              </SocialIcon>
            </SocialContainer>
          </Grid>

          <Grid item xs={12} md={4}>
            <FooterTitle variant="h6">
              Contact Information
            </FooterTitle>
            <FooterText variant="body2">
              📍 {address}
            </FooterText>
            <FooterText variant="body2">
              📞 <FooterLink href={`tel:${phone}`}>{phone}</FooterLink>
            </FooterText>
            <FooterText variant="body2">
              ✉️ <FooterLink href={`mailto:${email}`}>{email}</FooterLink>
            </FooterText>
          </Grid>

          <Grid item xs={12} md={4}>
            <FooterTitle variant="h6">
              Quick Links
            </FooterTitle>
            <FooterText variant="body2">
              <FooterLink href="#about">About Us</FooterLink>
            </FooterText>
            <FooterText variant="body2">
              <FooterLink href="#services">Our Services</FooterLink>
            </FooterText>
            <FooterText variant="body2">
              <FooterLink href="#products">Products</FooterLink>
            </FooterText>
            <FooterText variant="body2">
              <FooterLink href="#reviews">Reviews</FooterLink>
            </FooterText>
            <FooterText variant="body2">
              <FooterLink href="#contact">Contact Us</FooterLink>
            </FooterText>
          </Grid>
        </Grid>

        <Copyright>
          <Typography variant="body2" color="#94a3b8">
            © 2024 Your Business Name. All rights reserved. | Designed with ❤️ for success
          </Typography>
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
